// src/utils/errorHandler.ts
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export const handleApiError = (error: any) => {
  if (error.response) {
    // Server responded with error status
    throw new ApiError(
      error.response.data?.message || 'Server Error',
      error.response.status,
      error.response.data?.code
    );
  } else if (error.request) {
    // Network error
    throw new ApiError('Network Error', 0, 'NETWORK_ERROR');
  } else {
    // Other error - check if it's a JSON string
    let errorMessage = error.message || 'Unknown Error';
    
    // Try to parse JSON string to get the actual message
    if (typeof errorMessage === 'string' && errorMessage.startsWith('{')) {
      try {
        const parsedError = JSON.parse(errorMessage);
        errorMessage = parsedError.message || errorMessage;
      } catch {
        // If parsing fails, use the original message
      }
    }
    
    // Check for token expiry messages
    if (errorMessage.includes('Token expired') || errorMessage.includes('expired')) {
      throw new ApiError(errorMessage, 401, 'TOKEN_EXPIRED');
    }
    
    throw new ApiError(errorMessage, 0, 'UNKNOWN_ERROR');
  }
};
